import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';

export default class WorkOrderProcessFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderProcessNumber = '';
		this.productionDateFrom = '';
		this.productionDateTo = '';
		this.lineCodeId = '';
		this.lineCodeCode = '';
		this.processTypeId = '';
		this.processTypeCode = '';
		this.processTypeName = '';
		this.documentStatusId = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.notDocumentStatusId = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			workOrderProcessNumber: '0',
			productionDateFrom: '0',
			productionDateTo: '0',
			lineCodeId: '0',
			lineCodeCode: '0',
			processTypeId: '0',
			processTypeCode: '0',
			processTypeName: '0',
			documentStatusId: '0',
			documentStatusName: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			notDocumentStatusId: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}